module.exports = __webpack_public_path__ + "static/media/v-icon-white-thick.d0188b7b.svg";